import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./UserGroupsUIHelpers";

const UserGroupsUIContext = createContext();

export function useUserGroupsUIContext() {
  return useContext(UserGroupsUIContext);
}

export const UserGroupsUIConsumer = UserGroupsUIContext.Consumer;

export function UserGroupsUIProvider({ userGroupsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewUserGroupPage: userGroupsUIEvents.openNewUserGroupPage,
    openEditUserGroupPage: userGroupsUIEvents.openEditUserGroupPage,
  };

  return (
    <UserGroupsUIContext.Provider value={value}>
      {children}
    </UserGroupsUIContext.Provider>
  );
}